import { actionTypes } from '../reducers';

export const acReceivedUser = value => ({
    type: actionTypes.RECEIVED_USER,
    value,
});



// WEBPACK FOOTER //
// ./src/actions/user.js